enum GenderType {
  Woman,
  Man,
  Mixed,
}

export default GenderType;
